import React from 'react';
import Modal from 'jd-library/Modal';
import Button from 'jd-library/Button';
import withPortal from 'jd-library/withPortal';
import { useDispatch } from 'react-redux';
import { handleAIProductCreation, toggleAICreationModal, clickTrack } from '../../actions/products';
import './brochure-upload-modal.scss';

const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'webp'];
const PDF_GRAPHIC = 'https://image1.jdomni.in/jdomni_email/pdfGraphic_1904091817.png';

const EXT_COLORS = {
    doc: '#265299',
    docx: '#265299',
    xls: '#00733F',
    xlsx: '#00733F',
    ppt: '#E96924',
    pptx: '#E96924',
};

const FilePreviewItem = ({ file }) => {
    const ext = file.ext?.toLowerCase();
    const isImage = IMAGE_EXTS.includes(ext);
    const isPdf = ext === 'pdf';
    const extColor = EXT_COLORS[ext] || '#265299';
    if (isImage) {
        return <img src={file.url} alt={file.fileName} className="bum-image" />;
    }
    if (isPdf) {
        return (
            <div className="bum-file-preview">
                <img src={PDF_GRAPHIC} alt="pdf" className="bum-image" />
                <div className="bum-file-name">{file.fileName}</div>
            </div>
        );
    }
    return (
        <div className="bum-file-preview">
            <div className="bum-file-badge" style={{ background: extColor }}>
                <span className="bum-ext-name">{file.ext?.toUpperCase()}</span>
            </div>
            <div className="bum-file-name">{file.fileName}</div>
        </div>
    );
};

const BrochureUploadModal = ({ onHidden, uploadedFiles = [], catalogLabel }) => {
    const dispatch = useDispatch();

    const handleCreateWithAI = () => {
        dispatch(clickTrack({li: 'ai_product_create_pdf', ll: 'digital_catalog'}));
        const imageArr = uploadedFiles.map(f => ({ imageUrl: f.url,id: f.id }));
        dispatch(handleAIProductCreation({ imageArr, fromPhotoSlider: false }));
        window.history.back();
    };

    return (
        <Modal
            settings={{ modalId: 'brochure-upload-modal', class: 'brochure-upload-modal', variant: 'action' }}
            onHidden={() => {
                if(onHidden) {
                    onHidden();
                    return;
                }
                dispatch(toggleAICreationModal({brochureUploadModal: {show: false}}))
            }}
        >
            <Modal.CloseIcon />
            <Modal.Header>Add Photo to Product / Service</Modal.Header>
            <Modal.Body>
                <div className="bum-body">
                    {uploadedFiles.length ? (
                        <div className={`bum-preview${uploadedFiles.length === 1 ? ' justify-center' : ''}`}>
                            {uploadedFiles.map((file, i) => (
                                <FilePreviewItem key={i} file={file} />
                            ))}
                        </div>
                    ) : null}
                    <div className="bum-info-box">
                        Would you like to create products automatically using AI from your uploaded brochure?
                    </div>
                    <Button
                        block={true}
                        size='lg'
                        className="bum-ai-button"
                        onClick={handleCreateWithAI}
                    >
                        Create New Product using AI<span>✧</span>
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default withPortal(BrochureUploadModal);
